import {GLTF, GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader';

async function parseGltfFromArrayBuffer(loader: GLTFLoader, arrayBuffer: ArrayBuffer): Promise<GLTF> {
  return new Promise(resolve => loader.parse(arrayBuffer, '', resolve));
}

export {parseGltfFromArrayBuffer}
